import classNames from 'classnames';
import { format } from 'date-fns';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import PurchaseLabeledContainer from './PurchaseLabeledContainer';

import css from './PurchaseItemList.module.scss';

interface OwnProps {
  className?: string;
  labelType: string;
  merchantImage?: string;
  merchantId?: string;
  merchantName?: string;
  name?: string;
  price: number;
  expiryDate?: string;
  productUrl?: string;
}

type Props = OwnProps & InjectedIntlProps;

const PurchaseItemList = ({
  className,
  intl,
  price,
  expiryDate,
  productUrl,
  ...props
}: Props) => {
  const classes = classNames(css.PurchaseItemList, className);

  return (
    <PurchaseLabeledContainer
      label={intl.formatMessage({
        id: `purchases.purchaseItemList.title.${props.labelType}`,
      })}
      paddingTop={true}
    >
      <div className={classes}>
        {productUrl ? (
          <a className={css.PurchaseItemList__Link} href={productUrl}>
            <div className={css.PurchaseItemList__Inner}>
              {props.merchantImage ? (
                <img
                  className={css.PurchaseItemList__Image}
                  src={props.merchantImage}
                  alt={props.merchantName}
                />
              ) : (
                <span className={css.PurchaseItemList__Image} />
              )}
              <p className={css.PurchaseItemList__Name}>
                {props.merchantName}
                <span className={css.PurchaseItemList__Id}>
                  {props.merchantId}
                </span>
              </p>
            </div>
          </a>
        ) : (
          <div className={css.PurchaseItemList__Inner}>
            {props.merchantImage ? (
              <img
                className={css.PurchaseItemList__Image}
                src={props.merchantImage}
                alt={props.merchantName}
              />
            ) : (
              <span className={css.PurchaseItemList__Image} />
            )}
            <p className={css.PurchaseItemList__Name}>
              {props.merchantName}
              <span className={css.PurchaseItemList__Id}>
                {props.merchantId}
              </span>
            </p>
          </div>
        )}
        <dl className={css.PurchaseItemList__List}>
          <dt className={css.PurchaseItemList__ListTitle}>
            {intl.formatMessage({ id: 'common.totalPrice' })}
          </dt>
          <dd className={css.PurchaseItemList__ListData} data-style="price">
            {intl.formatMessage(
              { id: 'common.price' },
              { price: intl.formatNumber(price) },
            )}
          </dd>
        </dl>
        {expiryDate && (
          <dl className={css.PurchaseItemList__List}>
            <dt className={css.PurchaseItemList__ListTitle}>
              {intl.formatMessage({ id: 'common.expiryDate' })}
            </dt>
            <dd className={css.PurchaseItemList__ListData} data-style="date">
              {intl.formatDate(format(expiryDate), {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                weekday: 'short',
              })}
            </dd>
          </dl>
        )}
      </div>
    </PurchaseLabeledContainer>
  );
};

export default injectIntl(PurchaseItemList);
